var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2694 17.9896C28.2694 17.4715 28.0622 16.9948 27.6684 16.6217L11.2539 0.538859C10.8808 0.186528 10.4249 0 9.88601 0C8.82902 0 8 0.808289 8 1.88601C8 2.40414 8.20725 2.88082 8.53886 3.23316L23.6269 17.9896L8.53886 32.7461C8.20725 33.0984 8 33.5543 8 34.0933C8 35.171 8.82902 35.9792 9.88601 35.9792C10.4249 35.9792 10.8808 35.7927 11.2539 35.4198L27.6684 19.3575C28.0622 18.9637 28.2694 18.5078 28.2694 17.9896Z",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2694,
    height: 36,
    fill: "white",
    transform: "translate(8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.00c90a2c0863daade9c17913b9cc10fb.svg";
export { ForwardRef as ReactComponent };